// extracted by mini-css-extract-plugin
export default {"button":"CustomerLogin_button__i2j0n"};